
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.002 9.184l.568-.563a.928.928 0 00.188-.24c-.446-.03-.903-.24-1.283-.621-.903-.903-.897-2.186 0-3.088l2.42-2.414c.896-.903 2.18-.908 3.082-.006.908.914.908 2.197.005 3.094L9.898 6.418c.118.422.118.873.041 1.307l1.752-1.764c1.284-1.283 1.295-3.111-.006-4.418-1.3-1.3-3.128-1.29-4.412-.006L4.76 4.051c-1.283 1.283-1.295 3.111.006 4.412.375.38.802.633 1.236.72zm-4.682 2.73c1.301 1.3 3.13 1.29 4.418 0l2.508-2.508c1.29-1.289 1.3-3.117 0-4.418-.38-.38-.809-.627-1.236-.72l-.58.58a.957.957 0 00-.176.228c.445.03.902.24 1.283.621.902.903.897 2.186-.006 3.088L5.117 11.2c-.896.903-2.185.908-3.082.006-.902-.92-.908-2.191-.006-3.094l1.084-1.078a2.865 2.865 0 01-.04-1.3L1.32 7.49c-1.289 1.29-1.306 3.117 0 4.424z","fill":"#000"}})])
          )
        }
      }
    